import superagent from "superagent";
import * as superagentUse from "superagent-use";
import prefix from "superagent-prefix";

import { useUserServiceURL } from "./useUserServiceURL";

export function useUserService() {
  const url = useUserServiceURL();
  const service = superagentUse(superagent);
  service.use(prefix(url));
  return service;
}
